/**
 * Mock friend/user directory for the social feed prototype.
 *
 * Shape (mirrors the documented `PostAuthor` API contract — see
 * docs/home-redesign/DESIGN.md §9):
 *   { id, name, username, avatarColor, mutualFriends }
 *
 * There is no `avatarUrl` — DevFit doesn't have profile-photo upload yet,
 * so avatars render as a colored initial (same convention Sidebar.jsx
 * already uses for the logged-in user).
 */

export const CURRENT_USER_FALLBACK = {
  id: "me",
  name: "You",
  username: "you",
  avatarColor: "#39ff14",
};

export const MOCK_FRIENDS = [
  { id: "u1", name: "Rhea Kapoor", username: "rhea.lifts", avatarColor: "#ff6f91", mutualFriends: 6 },
  { id: "u2", name: "Marcus Chen", username: "marcuslifts", avatarColor: "#4facfe", mutualFriends: 3 },
  { id: "u3", name: "Priya Nair", username: "priya.runs", avatarColor: "#fa709a", mutualFriends: 9 },
  { id: "u4", name: "Diego Alvarez", username: "diego.strong", avatarColor: "#43e97b", mutualFriends: 2 },
  { id: "u5", name: "Sofia Rossi", username: "sofia.fit", avatarColor: "#a18cd1", mutualFriends: 5 },
  { id: "u6", name: "Kabir Singh", username: "kabir.gains", avatarColor: "#f6d365", mutualFriends: 1 },
  { id: "u7", name: "Ananya Roy", username: "ananya.moves", avatarColor: "#89f7fe", mutualFriends: 4 },
  { id: "u8", name: "Leo Fischer", username: "leo.lifts.big", avatarColor: "#f5576c", mutualFriends: 7 },
];
